exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.arrow[data-v-35c4e11d] {\n  border: solid #191919;\n  border-width: 0 1.5px 1.5px 0;\n  display: inline-block;\n  padding: 4px;\n  right: 20px;\n  bottom: 22px;\n}\n.left[data-v-35c4e11d] {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n", ""]);

// exports
